import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Tag } from '@naf-simba/elements-tag';
import useSelector from '../../../../../../redux/typedHooks';
import { actions } from '../../../../../../redux/modules/myMembership';
import { useAuth0Token } from '../../../../../../hooks/useAuth0Token';
import { ArticleBlockContentGridCol } from '../ArticleBlockContentGridCol';
import { formatDateWithMonthName } from '../../../../../../utils/Dates';
import { BlockContentContext } from '../../../../BlockContent.utils';
import * as S from './NumberOfRoadsideAssistance.styles';

export const NumberOfUsedRoadAssistanceBlock = () => {
  const dispatch = useDispatch();
  const { simpleToken } = useAuth0Token();
  const roadSideAssistance = useSelector(
    (state) => state.myMembership.customerInformation.data.membership?.roadSideAssistance,
  );
  const fetchState = useSelector((state) => state.myMembership.customerInformation.meta.fetchState);

  useEffect(() => {
    if (simpleToken && fetchState === 'initial') {
      dispatch(actions.getCustomerInformation.request(simpleToken));
    }
  }, [simpleToken, dispatch, fetchState]);

  return (
    <>
      {roadSideAssistance && roadSideAssistance?.isActivationPeriod ? (
        <S.ContentWrapper>
          <S.BoldSpan>
            Din veihjelp er gyldig fra {formatDateWithMonthName(roadSideAssistance?.activationDate)}
          </S.BoldSpan>
          <p>
            Veihjelp uten egenandel har en karenstid på to døgn fra du blir medlem. Du kan få hjelp, mot betaling, i
            karensdagene.
          </p>
          <br />
        </S.ContentWrapper>
      ) : null}
      {roadSideAssistance && !roadSideAssistance.isActivationPeriod ? (
        <S.RoadsideAssistanceWrapper>
          <S.BoldSpan>Du har 4 årlige assistanser</S.BoldSpan>
          <S.LabelWrapper>
            <Tag
              color="secondary"
              shade="light"
              text={`Du har brukt ${roadSideAssistance.usedRoadsideAssistancesInPeriod} av ${roadSideAssistance.totalFreeRoadsideAssistancesInPeriod}`}
            />
          </S.LabelWrapper>
        </S.RoadsideAssistanceWrapper>
      ) : null}
    </>
  );
};

export const NumberOfUsedRoadAssistanceSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return () => (
      <ArticleBlockContentGridCol>
        <NumberOfUsedRoadAssistanceBlock />
      </ArticleBlockContentGridCol>
    );
  }
  return () => <NumberOfUsedRoadAssistanceBlock />;
};
